export const monthsList = [
  {
    label: 'January',
    value: '1',
    days: 31
  },
  {
    label: 'February',
    value: '2',
    days: 29
  },
  {
    label: 'March',
    value: '3',
    days: 31
  },
  {
    label: 'April',
    value: '4',
    days: 30
  },
  {
    label: 'May',
    value: '5',
    days: 31
  },
  {
    label: 'June',
    value: '6',
    days: 30
  },
  {
    label: 'July',
    value: '7',
    days: 31
  },
  {
    label: 'August',
    value: '8',
    days: 31
  },
  {
    label: 'September',
    value: '9',
    days: 30
  },
  {
    label: 'October',
    value: '10',
    days: 31
  },
  {
    label: 'November',
    value: '11',
    days: 30
  },
  {
    label: 'December',
    value: '12',
    days: 31
  }
];

export const getDaysList = () => {
    let daysList = [];
    for (var i = 1; i < 31 + 1; i++) {
        daysList.push({
          value: i.toString(),
          label: i.toString()
        });
    }

    return daysList;
};